var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 396,
    viewBox: "0 0 430 396",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.152 178.546V141.707",
    stroke: "white",
    strokeWidth: 1.99311,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0293 73.1774L65.2691 57.6606",
    stroke: "white",
    strokeWidth: 0.398622,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6914 84.9857L62.2185 82.4023",
    stroke: "white",
    strokeWidth: 0.398622,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.531 227.35L266.862 177.605",
    stroke: "white",
    strokeWidth: 1.99311,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.553 122.062V85.2222",
    stroke: "white",
    strokeWidth: 1.99311,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0977 87.5365L38.0977 11.3384",
    stroke: "white",
    strokeWidth: 0.848132,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9297 170.865L167.264 121.121",
    stroke: "white",
    strokeWidth: 1.99311,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0293 62.5172L65.2691 47.0005",
    stroke: "white",
    strokeWidth: 0.398622,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0293 52.0943L65.2691 36.5776",
    stroke: "white",
    strokeWidth: 0.398622,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0293 41.6334L65.2691 26.1167",
    stroke: "white",
    strokeWidth: 0.398622,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3867 70.6343L76.9896 91.1793",
    stroke: "white",
    strokeWidth: 0.398622,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 53.5083L74.1581 65.4188",
    stroke: "white",
    strokeWidth: 0.398622,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.873 42.3433L43.3965 49.1848",
    stroke: "white",
    strokeWidth: 0.398622,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M260.811 288.129L379.455 358.561",
    stroke: "white",
    strokeWidth: 1.99311,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M254.223 291.425L372.868 361.858",
    stroke: "white",
    strokeWidth: 1.99311,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0216 91.1789C36.0209 91.1789 34.3951 89.5693 34.3829 87.5768C34.3707 85.5842 35.9843 83.9624 37.985 83.9502C40.0346 83.9421 41.693 85.5761 41.6726 87.5849C41.6482 89.5775 40.0224 91.1789 38.0216 91.1789Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M266.858 144.615C264.857 144.615 263.231 143.006 263.219 141.013C263.207 139.021 264.82 137.399 266.821 137.387C268.871 137.379 270.529 139.013 270.509 141.021C270.484 143.014 268.858 144.615 266.858 144.615Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M167.258 88.1354C165.257 88.1354 163.631 86.5259 163.619 84.5333C163.607 82.5407 165.221 80.919 167.221 80.9068C169.271 80.8986 170.929 82.5326 170.909 84.5415C170.885 86.534 169.259 88.1354 167.258 88.1354Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0931 12.5606C36.7511 12.5606 35.6606 11.4719 35.6524 10.124C35.6442 8.7762 36.7265 7.67919 38.0685 7.67092C39.4432 7.66541 40.5556 8.77068 40.5419 10.1295C40.5255 11.4774 39.435 12.5606 38.0931 12.5606Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2662 26.8877C64.4024 26.8877 63.6975 26.191 63.6934 25.3271C63.6893 24.4673 64.3861 23.7624 65.2499 23.7583C66.1382 23.7542 66.8554 24.4633 66.8432 25.3312C66.835 26.195 66.1301 26.8877 65.2622 26.8877H65.2662Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2662 38.1138C64.4024 38.1138 63.6975 37.417 63.6934 36.5532C63.6893 35.6934 64.3861 34.9885 65.2499 34.9844C66.1382 34.9803 66.8554 35.6893 66.8432 36.5573C66.835 37.4211 66.1301 38.1138 65.2622 38.1138H65.2662Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2662 48.565C64.4024 48.565 63.6975 47.8682 63.6934 47.0044C63.6893 46.1446 64.3861 45.4396 65.2499 45.4356C66.1382 45.4315 66.8554 46.1405 66.8432 47.0084C66.835 47.8723 66.1301 48.565 65.2622 48.565H65.2662Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2662 59.2246C64.4024 59.2246 63.6975 58.5279 63.6934 57.664C63.6893 56.8042 64.3861 56.0993 65.2499 56.0952C66.1382 56.0912 66.8554 56.8002 66.8432 57.6681C66.835 58.5319 66.1301 59.2246 65.2622 59.2246H65.2662Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9088 92.7403C76.045 92.7403 75.34 92.0435 75.336 91.1796C75.3319 90.3199 76.0287 89.6149 76.8925 89.6109C77.7808 89.6068 78.498 90.3158 78.4857 91.1837C78.4776 92.0476 77.7727 92.7403 76.9047 92.7403H76.9088Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5612 66.9834C73.6973 66.9834 72.9924 66.2867 72.9883 65.4228C72.9842 64.563 73.681 63.8581 74.5449 63.854C75.4332 63.8499 76.1503 64.5589 76.1381 65.4269C76.1299 66.2907 75.425 66.9834 74.5571 66.9834H74.5612Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5729 43.9078C30.709 43.9078 30.0041 43.211 30 42.3471C29.9959 41.4873 30.6927 40.7824 31.5566 40.7783C32.4449 40.7743 33.162 41.4833 33.1498 42.3512C33.1417 43.215 32.4367 43.9078 31.5688 43.9078H31.5729Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6881 86.5464C56.8243 86.5464 56.1193 85.8496 56.1153 84.9858C56.1112 84.126 56.808 83.4211 57.6718 83.417C58.5601 83.4129 59.2773 84.1219 59.265 84.9899C59.2569 85.8537 58.552 86.5464 57.684 86.5464H57.6881Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M150.092 308.299C148.091 308.299 146.465 306.69 146.453 304.697C146.441 302.705 148.055 301.083 150.055 301.071C152.105 301.063 153.763 302.697 153.743 304.706C153.718 306.698 152.093 308.299 150.092 308.299Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.098 305.272V354.425L271.86 281.116L38.0293 145.72V88.604",
    stroke: "white",
    strokeWidth: 1.99311,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M364.207 377.309C349.416 377.309 337.383 365.179 337.297 350.183C337.212 335.188 349.151 322.964 363.95 322.887C379.121 322.809 391.394 335.123 391.223 350.241C391.052 365.256 379.019 377.313 364.207 377.309Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 5.64856,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M335.402 354.968H327.143V344.239H335.402",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M339.579 333.355L333.801 327.454L341.465 319.949L347.243 325.849",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M358.105 321.705V313.446H368.838V321.705",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M391.74 354.968H400V344.239H391.74",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M387.565 333.355L393.343 327.454L385.678 319.949L379.9 325.849",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M335.402 344.422H327.143V355.151H335.402",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M339.579 366.034L333.801 371.939L341.465 379.444L347.243 373.54",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M358.105 377.688V385.948H368.838V377.688",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M391.74 344.422H400V355.151H391.74",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M387.565 366.034L393.343 371.939L385.678 379.444L379.9 373.54",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M364.252 370.358C375.443 370.358 384.516 361.285 384.516 350.094C384.516 338.902 375.443 329.83 364.252 329.83C353.061 329.83 343.988 338.902 343.988 350.094C343.988 361.285 353.061 370.358 364.252 370.358Z",
    fill: "#726659",
    stroke: "white",
    strokeWidth: 0.648821,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.fa9720b7a3ee0d2fedd2389247ada9e9.svg";
export { ForwardRef as ReactComponent };